import { useTranslation } from 'react-i18next';
import { Table } from '@/components/Table';
import { moneyLabel } from '@/pages/Opportunities/dates';
import type { Bc3Data } from '@/pages/Opportunities/types';

export interface OfferBudgetProps { data: Bc3Data; currency: string; }
export const OfferBudget = ({ data, currency }: OfferBudgetProps) => {
    const { t, i18n } = useTranslation('global');
    const rows = Object.entries(data.decompositions).flatMap(([parent, children]) => children.map(child => ({
        parent, code: child.code, summary: data.concepts[child.code]?.summary ?? '', factor: child.factor, quantity: child.quantity, price: data.concepts[child.code]?.price ?? null,
    })));
    return <section className="space-y-4">
        <p>{t('opportunities.bc3_base')}: {moneyLabel(data.base_amount, currency, i18n.language)}</p>
        <p>{t('opportunities.bc3_result')}: {moneyLabel(data.amount, currency, i18n.language)}</p>
        <Table title={t('opportunities.bc3_concepts')} searchable paginated appearance="workspace" data={Object.values(data.concepts)} columns={[
            { key: 'code', label: t('opportunities.fields.code') }, { key: 'summary', label: t('opportunities.concept') }, { key: 'unit', label: t('opportunities.unit') },
            { key: 'price', label: t('opportunities.price'), render: concept => moneyLabel(concept.price, currency, i18n.language) },
        ]} />
        <Table title={t('opportunities.bc3_decomposition')} searchable paginated appearance="workspace" data={rows} columns={[
            { key: 'parent', label: t('opportunities.parent_concept') }, { key: 'code', label: t('opportunities.fields.code') }, { key: 'summary', label: t('opportunities.concept') },
            { key: 'factor', label: t('opportunities.factor') }, { key: 'quantity', label: t('opportunities.quantity') },
            { key: 'price', label: t('opportunities.price'), render: row => moneyLabel(row.price, currency, i18n.language) },
        ]} />
        <Table title={t('opportunities.measurements')} searchable paginated appearance="workspace" data={data.measurements} columns={[
            { key: 'reference', label: t('opportunities.concept') }, { key: 'total', label: t('opportunities.quantity') },
        ]} />
    </section>;
};
